import { render, staticRenderFns } from "./InfoEvent.vue?vue&type=template&id=574f6cd7&scoped=true&"
import script from "./InfoEvent.vue?vue&type=script&lang=js&"
export * from "./InfoEvent.vue?vue&type=script&lang=js&"
import style0 from "./InfoEvent.vue?vue&type=style&index=0&id=574f6cd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574f6cd7",
  null
  
)

export default component.exports